import { FC, useState } from "react";
import { DataTableFilterSpec, SearchInput } from "../../design-system";
import { User } from "../../types/UserGroup";
import { UserList } from "./UserList";
import styles from "./OwnerFilter.module.less";

/** An Owner filter's editor: a search box over the org's users. */
export const OwnerFilterEditor: FC<{
    value?: string;
    onChange: (value: string | undefined) => void;
}> = ({ value, onChange }) => {
    const [query, setQuery] = useState("");
    return (
        <div>
            <div className={styles.search}>
                <SearchInput
                    autoFocus
                    placeholder="Search people…"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                />
            </div>
            <UserList
                selectedId={value ? Number(value) : undefined}
                onSelect={(user) => onChange(String(user.id))}
                query={query}
            />
        </div>
    );
};

/**
 * A table column's Owner filter: one user picked from the org's list, the
 * chip naming them. `users` (from useUsers) is only for the chip's label.
 */
export const ownerFilter = <T,>(
    ownerId: (row: T) => number | undefined,
    users: User[] | undefined
): DataTableFilterSpec<T> => ({
    type: "pick",
    render: (value, onChange) => <OwnerFilterEditor value={value} onChange={onChange} />,
    label: (value) => users?.find((u) => u.id === Number(value))?.name ?? "…",
    match: (row, value) => ownerId(row) === Number(value),
});
